import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Table,
  Typography,
} from "@mui/material";

import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import moment from "moment";

import img1 from "../../../../../../src/assets/images/img1.jpeg";
import img2 from "../../../../../../src/assets/images/img2.jpeg";

const styles = StyleSheet.create({
  page: {
    paddingVertical: 20,
    paddingHorizontal: 20,
  },
  row: {
    flexDirection: "row",
  },
  column: {},
  section: {
    margin: 1,
    padding: 1,
    width: "50%",
    // borderWidth: 1,
    // borderColor: "green",
  },
  header: {
    backgroundColor: "#D5D3D3",
    flexDirection: "row",
  },
  header2: {
    backgroundColor: "#ECEAEA",
    flexDirection: "row",
    borderBottomWidth: 0.2,
  },
  dataRow: {
    flexDirection: "row",
    borderBottomWidth: 0.5,
    borderBottomColor: "#D5D3D3",
  },
  tableCell: {
    // paddingVertical: 2,
    paddingVertical: 10,
    // borderWidth: 1,
    paddingHorizontal: 2,
    // justifyContent: "center",
    // alignItems: "center",
  },
});

const InvoicePdf = ({ data }) => {
  Font.register({
    family: "Open Sans",
    fonts: [
      { src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf" },
      {
        src: "https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf",
        fontWeight: 600,
      },
    ],
  });

  const FirstLayer = () => {
    return (
      <View style={styles.row}>
        <View style={styles.section}>
          <View style={styles.column}>
            <Image resizeMode="contain" style={{ width: "50%" }} src={img1} />
          </View>
        </View>
        <View style={styles.section}>
          <View style={[styles.column, { alignItems: "flex-end" }]}>
            <Text style={{ fontFamily: "Open Sans", fontWeight: "900", fontSize: 15 }}>
              TAX INVOICE
            </Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              Invoice # : <Text style={{ fontWeight: "normal" }}>{data.invoiceNumber}</Text>
            </Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              Generated On :{" "}
              <Text style={{ fontWeight: "normal" }}>
                {moment.utc(data.createDateTime).local().format("DD-MM-YYYY HH:mm")}
              </Text>
            </Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              Created By : <Text style={{ fontWeight: "normal" }}>{data.createdBy}</Text>
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const SecondLayer = () => {
    const { toOrganisation, fromOrganisation } = data;
    return (
      <View style={styles.row}>
        <View style={styles.section}>
          <View style={[styles.column]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              {fromOrganisation.name}
            </Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{fromOrganisation.address}</Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              Contact Number :{" "}
              <Text style={{ fontWeight: "normal" }}>{fromOrganisation.contactNumber}</Text>
            </Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              Email : <Text style={{ fontWeight: "normal" }}>{fromOrganisation.email}</Text>
            </Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              TRN : <Text style={{ fontWeight: "normal" }}>""</Text>
            </Text>
          </View>
        </View>
        <View style={styles.section}>
          <View
            style={[
              styles.column,
              {
                alignItems: "center",
                justifyContent: "flex-end",
                flexGrow: 1,
              },
            ]}
          >
            <Image style={{ width: "50%" }} src={img2} />
          </View>
        </View>
        <View style={styles.section}>
          <View style={[styles.column, { alignItems: "flex-end" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              Billing To
            </Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              {toOrganisation.name}
            </Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{toOrganisation.address}</Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              Contact No : <Text style={{ fontWeight: "normal" }}>{toOrganisation.address}</Text>
            </Text>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8, fontWeight: "600" }}>
              Email : <Text style={{ fontWeight: "normal" }}>{toOrganisation.mail}</Text>
            </Text>
          </View>
        </View>
      </View>
    );
  };

  const TableArea = () => {
    const { tickets, labelKey, labelValue, totalFees, totalAmount, totalTax, discount, paid } =
      data;
    return (
      <View style={{ paddingVertical: 20 }}>
        <View style={styles.header}>
          <View style={[styles.tableCell, { width: "5%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>#</Text>
          </View>
          <View style={[styles.tableCell, { width: "30%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Service</Text>
          </View>
          <View style={[styles.tableCell, { width: "30%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Description</Text>
          </View>
          <View style={[styles.tableCell, { width: "12%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Fees/Rate</Text>
          </View>
          <View style={[styles.tableCell, { width: "13%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Tax</Text>
          </View>
          <View style={[styles.tableCell, { width: "10%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Total</Text>
          </View>
        </View>
        {tickets.map((row, index) => (
          <View style={styles.dataRow}>
            <View style={[styles.tableCell, { width: "5%" }]}>
              <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{index + 1}</Text>
            </View>
            <View
              style={[styles.tableCell, { width: "30%", flexWrap: "wrap", wordWrap: "break-word" }]}
            >
              <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{row.serviceName}</Text>
              <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Transaction Number :</Text>
              <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>
                {row.transactionNumber.split("")}
              </Text>
            </View>
            <View style={[styles.tableCell, { width: "30%" }]}>
              <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{row.description}</Text>
            </View>
            <View style={[styles.tableCell, { width: "12%" }]}>
              <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{row.fees}</Text>
            </View>
            <View style={[styles.tableCell, { width: "13%" }]}>
              <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{row.tax}</Text>
            </View>
            <View style={[styles.tableCell, { width: "10%" }]}>
              <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{row.total}</Text>
            </View>
          </View>
        ))}
        <View style={[styles.dataRow, { borderBottomWidth: 5, borderColor: "#C0C0C0" }]}>
          <View style={[styles.tableCell, { width: "35%" }]}></View>
          <View style={[styles.tableCell, { width: "30%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Total</Text>
          </View>
          <View style={[styles.tableCell, { width: "12%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{totalFees}</Text>
          </View>
          <View style={[styles.tableCell, { width: "13%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{totalTax}</Text>
          </View>
          <View style={[styles.tableCell, { width: "10%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{totalAmount}</Text>
          </View>
        </View>
        <View style={styles.header2}>
          <View style={[styles.tableCell, { width: "77%" }]}></View>
          <View style={[styles.tableCell, { width: "13%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Discount</Text>
          </View>
          <View style={[styles.tableCell, { width: "10%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{discount}</Text>
          </View>
        </View>
        <View style={styles.header2}>
          <View style={[styles.tableCell, { width: "77%" }]}></View>
          <View style={[styles.tableCell, { width: "13%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Grand Total</Text>
          </View>
          <View style={[styles.tableCell, { width: "10%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{totalAmount}</Text>
          </View>
        </View>
        <View style={styles.header2}>
          <View style={[styles.tableCell, { width: "77%" }]}></View>
          <View style={[styles.tableCell, { width: "13%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Paid</Text>
          </View>
          <View style={[styles.tableCell, { width: "10%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{paid}</Text>
          </View>
        </View>
        <View style={styles.header2}>
          <View style={[styles.tableCell, { width: "50%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{labelKey}</Text>
          </View>
          <View style={[styles.tableCell, { width: "%50%" }]}>
            <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>{labelValue}</Text>
          </View>
        </View>
      </View>
    );
  };

  const SignatureArea = () => {
    return (
      <View style={styles.row}>
        <View style={{ flexGrow: 1, justifyContent: "center", alignItems: "center" }}>
          <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Customer Signature</Text>
        </View>
        <View style={{ flexGrow: 1, justifyContent: "center", alignItems: "center" }}>
          <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Authorised Signature</Text>
        </View>
      </View>
    );
  };

  const test = "1232534546546456546455345345346346";
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <FirstLayer />
        <SecondLayer />
        <TableArea />
        <SignatureArea />
      </Page>
    </Document>
  );
};

export default InvoicePdf;
